import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useConvexAuth } from "convex/react";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Settings from "./pages/Settings";
import AppShell from "./components/layout/AppShell";
import ImportsSettingsPage from "./pages/settings/ImportsSettingsPage";
import NotificationsSettingsPage from "./pages/settings/NotificationsSettingsPage";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./context/ThemeContext";
import {
  LocalizationProvider,
  useLocalization,
} from "./context/LocalizationContext";
import "./App.css";

function AppRoutes() {
  const { isLoading, isAuthenticated } = useConvexAuth();
  const { t } = useLocalization();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <div className="text-zinc-500">{t("common.loading")}</div>
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={!isAuthenticated ? <Login /> : <Navigate to="/" />}
      />
      <Route
        path="/signup"
        element={!isAuthenticated ? <Signup /> : <Navigate to="/" />}
      />
      <Route
        element={isAuthenticated ? <AppShell /> : <Navigate to="/login" />}
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/settings" element={<Settings />}>
          <Route index element={<Navigate to="imports" replace />} />
          <Route path="imports" element={<ImportsSettingsPage />} />
          <Route
            path="notifications"
            element={<NotificationsSettingsPage />}
          />
        </Route>
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LocalizationProvider>
        <div className="App">
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <Toaster position="top-center" />
        </div>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
